module.exports = __webpack_public_path__ + "static/Moonlighter3-9dd5b842f09dd9eb9900f0998f6d45d2.png";